import { NgModule } from '@angular/core';

import { AppComponentUIModule } from './ui/app-component-ui.module';
import { ModalModule } from './modal/modal.module';

@NgModule({
  imports: [
    AppComponentUIModule,
    ModalModule,
  ],
  exports: [
    AppComponentUIModule,
    ModalModule,
  ]
})
export class AppComponentModule {

}



// WEBPACK FOOTER //
// ./src/app/core/component/app-component.module.ts